import {cancelCircleFilledSvg as Icon__small__cancelCircleFilledSvg} from '../Icon__small/Icon__small--cancelCircleFilled.js'

export var cancelCircleFilled = {
  name: 'cancelCircleFilled',
  category: 'icon',
  colorable: true,
  svg: Icon__small__cancelCircleFilledSvg,
};
